// removed by extract-text-webpack-plugin
module.exports = {"adminPitchMessages":"AdminPitchMessages__adminPitchMessages___2u2nV","adminPitchMessagesContainer":"AdminPitchMessages__adminPitchMessagesContainer___XTVm-"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/project/messages/components/AdminPitchMessages.scss
// module id = 1575
// module chunks = 0